import "react-app-polyfill/ie9";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React, { useContext } from "react";
import App from "../Geotolk/App";
import { useQuery } from "react-query";
import { fetchBoreholeList } from "../Geotolk/api/fetchBoreholeList";
import { useParams } from "react-router-dom";
import { useAuthInfo } from "@propelauth/react";



const Geotolk = () => {
  const crs = [
    { zone: "UTM", number: 32, hemisphere: "N", srid: 25832 },
    { zone: "UTM", number: 33, hemisphere: "N", srid: 25833 },
    { zone: "UTM", number: 35, hemisphere: "N", srid: 32635 },
    { zone: "LON/LAT", number: null, hemisphere: null, srid: 4326 },
    { zone: "NTM", number: 10, hemisphere: null, srid: 5110 },
    { zone: "NTM", number: 11, hemisphere: null, srid: 5111 },
    { zone: "NTM", number: 9, hemisphere: null, srid: 5109 },
    { zone: "NTM", number: 8, hemisphere: null, srid: 5108 },
    { zone: "NTM", number: 4, hemisphere: null, srid: 5104 },
  ];

  const { project_id,srid} = useParams();
  const user = useAuthInfo();
  const token = user.accessToken;
  const accountInfo = { account: { userName: user.user.userId } };

  const { status, data, isLoading, error } = useQuery(
    [project_id],
    () => fetchBoreholeList(project_id, token),
    {
      staleTime: 900000, // 15 minutes
      // backgroundFetchInterval: 3000 // 3 seconds backgroundfetching but the app stays wont work. need async db 

    }
  );

  if (isLoading) {
    console.log("loading");
    return <div>...Loading the data</div>;
  }

  if (error) {
    return "error" + error.message;
  }

  if (status === "success") {
    const currentCoordinateSystem = crs.find((crs) => crs.srid === parseInt(srid));
    console.log(srid)
    return (
      <App
        token={token}
        srid={srid}
        crs={crs}
        currentCoordinateSystem={currentCoordinateSystem}
        boreholeList={data}
        project_id={project_id}
        logout={false}
        accountInfo={accountInfo}
      />
    );
  }
  return <div>...Loading the data</div>;
};

export default Geotolk;
